import React from 'react';
// Components
import Icon from '../components/icon';
// Assets
import marque from '../../images/sprite/marque.svg';

const Credit = () => (
  <div className="credit">
    <a href="http://neverbland.com/" target="_blank" rel="noopener noreferrer"><Icon className="credit__icon" glyph={marque} /></a>
    <p className="credit__text">Made by <a href="http://neverbland.com/" target="_blank" rel="noopener noreferrer">Neverbland</a></p>
  </div>
);

export default Credit;



/** WEBPACK FOOTER **
 ** ./src/js/components/credit.js
 **/